<template>
    <v-card dark>
        <v-overlay :value="loading" absolute opacity="0.85" class="overflow:hidden;">
            <v-progress-circular class="ma-3" indeterminate large color="secondary" />
        </v-overlay>
        <v-toolbar class="text-overline" dark>Use Inventory</v-toolbar>
        <v-card-text class="pa-5">
            <v-select
                v-model="selectedSerial"
                :items="serials"
                outlined
                dense
                :loading="$apollo.loading"
                :disabled="$apollo.loading"
                hide-details
                label="Select Serial"
                item-text="sn"
                item-value="sn"
                no-data-text="No in-warranty serials available"
            ></v-select>
        </v-card-text>
        <v-col cols="12">
            <base-divider class="mt-0 mb-0" color="primary" space="3" max-width="100%" />
        </v-col>
        <v-card-actions class="pt-0 pb-5">
            <v-btn elevation="0" text @click="$emit('cancel')">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="#db5120" dark elevation="0" :disabled="!selectedSerial" @click="useItem">Submit</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import gql from 'graphql-tag'

export default {
    name: 'SeedStock',
    props: {
        item: {
            type: Object,
            required: false,
            default: () => {}
        }
    },
    apollo: {
        queryRegisteredSNList: {
            query: gql`
                query QueryRegisteredSNList($customerId: String) {
                    queryRegisteredSNList(customerId: $customerId) {
                        inwarranty
                        sn
                        model
                    }
                }
            `,
            fetchPolicy: `network-only`,
            variables() {
                return {
                    customerId: this.$auth.user.org.branchId
                }
            },
            update(data) {
                this.serials = data.queryRegisteredSNList.filter((e) => this.checkSerial(e))
                this.loading = false
            }
        }
    },
    data() {
        return {
            loading: true,
            serials: [],
            selectedSerial: ``
        }
    },
    computed: {},
    watch: {
        item: {
            immediate: true,
            handler() {
                this.selectedSerial = ``
            }
        }
    },
    methods: {
        checkSerial(serial) {
            const inWarranty = serial.inwarranty === 'Yes'
            const modelFamily = serial.model.includes(this.item.modelFamily)
            return modelFamily && inWarranty
        },
        useItem() {
            this.loading = true
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation UseItem($smId: String!, $sn: String!) {
                            useItem(smId: $smId, sn: $sn)
                        }
                    `,
                    variables: { smId: this.item.smId, sn: this.selectedSerial }
                })
                .then((data) => {
                    this.$emit('submitted', data)
                })
                .catch((e) => {
                    this.$emit('errorSubmit', e)
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>
